import $ from 'jquery'
import Mmenu from 'mmenu-js'
import 'mmenu-js/dist/mmenu.polyfills'

document.addEventListener('DOMContentLoaded', () => {
	const menu = new Mmenu(
		'#mobile_menu_js',
		{
			counters: true,
			extensions: ['pagedim-black', 'position-right', 'shadow-page', 'shadow-panels'],
		},
		{
			// configuration
			offCanvas: {
				page: {
					selector: '#wrapper',
				},
			},
		}
	)

	const api = menu.API

	document.getElementById('main_menu_toggle_js').addEventListener('click', event => {
		event.preventDefault()

		api.open()

		$('.fa-times').addClass('show').removeClass('hide')
		$('.fa-bars').addClass('hide').removeClass('show')
	})

	$('.mm-wrapper__blocker').on('click', toggle_menu_icons)
	$('.mm-wrapper__blocker').on('touchstart', toggle_menu_icons)

	function toggle_menu_icons() {
		$('.fa-times').addClass('hide').removeClass('show')
		$('.fa-bars').addClass('show').removeClass('hide')
	}

	$('#mobile_menu_js').removeClass('hidden')
})
